import { render, staticRenderFns } from "./clienteNuevo.vue?vue&type=template&id=1804206b&scoped=true&"
import script from "./clienteNuevo.vue?vue&type=script&lang=js&"
export * from "./clienteNuevo.vue?vue&type=script&lang=js&"
import style0 from "./clienteNuevo.vue?vue&type=style&index=0&id=1804206b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1804206b",
  null
  
)

export default component.exports